import React from "react";
import {
  Button,
  Col,
  Container,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/maps.scss";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import filterIcon from "../../assets/images/filter_rgb_red.svg";

const MapsButtons = ({ onSearch, filters = {}, searchArea }) => {
  const navigate = useNavigate();
  const renderEditTooltip = (props) => (
    <Tooltip id="edit-tooltip" {...props}>
      Edytuj wszystkie spełniające filtr
    </Tooltip>
  );
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        onSearch?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onSearch]);
  
  const handleEditWithFilters = () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    
    navigate(`/information/bulkupdate?${queryParams.toString()}`, {
      state: { searchArea }
    });
  };
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderEditTooltip}
          >
            <Button className="maps-button" onClick={handleEditWithFilters}>
              <img
                src={filterIcon}
                alt="Edit"
                style={{ width: "70%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <Button className="maps-button" onClick={onSearch}>
            <img
              src={searchIcon}
              alt="Search"
              style={{ width: "75%", height: "75%" }}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default MapsButtons;
